<img [src]="logoSrc" *ngIf="theme">
<div class="flags" (click)="availableHidden = !availableHidden" *ngIf="theme">
    <div class="selected">
        <img [src]="getSelectedFlag()">
        <img [src]="'assets/imgs/shared/icons/Keyboard arrow down.png'" class="arrow">
    </div>
    <div class="availables"
    [ngStyle]="{'height': !availableHidden ? '0px': '100px'}">
        <ng-container  *ngFor="let flag of theme.header.lang.available;">
            <div class="flag" *ngIf="flag.name !== selectedLang">
                <img [src]="flag.flag" (click)="setSelectedLang(flag.name)">
            </div>
        </ng-container>
    </div>
</div>